import { z } from "zod";
import { capitalize } from "../../../strings";
import { uploadResultsSchema } from "../../files";
import { ZodStringNullable } from "../../zod-types/zod-string-nullable";

export const patchUserSchema = z.object({
	firstName: z.string().min(1, "First name is required").transform(capitalize),
	lastName: z.string().min(1, "Last name is required").transform(capitalize),
	email: z.email(),
	phone: ZodStringNullable,
	image: uploadResultsSchema.optional(),
});

export type PatchUserForm = z.infer<typeof patchUserSchema>;
